module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jjylzy.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjjylzy.png
// module id = Tybz
// module chunks = 93